<template>
  <div class="margin-subpages">
    <div class="flex-row-between mt-24">
      <el-select v-model="selectTeam" filterable placeholder="Select" class="input-style"
      :class="[ blurMode ?  'blurelement': '' ]" @change="handleTeams">
        <el-option v-if="user.user_type !== 'leadership'" class="text-dropdown" key="all" :label="`All Teams (${$utils(
        'addCommasInNumber',
        optionsTeam.length
      )})`" value="all"></el-option>
        <el-option class="text-dropdown" 
        :class="[ blurMode ?  'blurelement': '' ]"v-for="item in optionsTeam" :key="item.key" :label="item.name"
          :value="item.key"></el-option>
      </el-select>
      <div style="width: 220px" id="menuDropdownType" class="flex">
        <el-menu class="el-menu-demo menu-option-style" mode="horizontal">
          <el-submenu index="0" style="width: 220px">
            <template slot="title">
              <span class="txtOption">{{ list_month_select }} </span>
            </template>
            <el-menu-item index="1" @click="changeTime('All-time')"
              style="font-size: 14px; width: 220px">All-time</el-menu-item>
            <el-menu-item index="2" @click="changeTime('Past year')" style="font-size: 14px; width: 220px">Past
              year</el-menu-item>
            <el-menu-item index="3" @click="changeTime('Past 6-months')" style="font-size: 14px; width: 220px">Past
              6-months</el-menu-item>
            <el-menu-item index="4" @click="changeTime('Past 3-months')" style="font-size: 14px; width: 220px">Past
              3-months</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>


    <div id="byManager">
      <div class="mt-24 fs-18 fw-700">Overview</div>
      <div class="overview mt-20 pt-30 pr-24 pl-24 pb-24">
        <div class="icon-buttom-loading flex-mid" v-if="loading">
          <loading-even></loading-even>
        </div>
        <div v-else class="flex-row-between " style="width:100% ;height: 100px;column-gap:41px;">
          <div class="fc-000 ">
            <div class="fs-14 fw-700 ">Rating Overview</div>
            <div class="fs-12 pt-6" style="color: #000000; opacity: 0.6;">A distribution of ratings towards company
              goals
              from peer feedback interactions.</div>
            <div class="flex-center pt-24">
              <div style="width:140px;height:140px;">
                <canvas ref="ratingChart" width="140" height="140"></canvas>
              </div>

              <div class="pl-20">
                <div class="flex-row">
                  <div class="label-pie mr-6" style="background-color: #6C30CC;"></div>
                  <div class="fs-11" style="align-content:center">Truly Outstanding</div>
                </div>

                <div class="flex-row  mt-6">
                  <div class="label-pie mr-6" style="background-color: #8858d5;"></div>
                  <div class="fs-11" style="align-content:center">Exceeding Expectations</div>
                </div>
                <div class="flex-row  mt-6">
                  <div class="label-pie mr-6" style="background-color: #c1a9e8;"></div>
                  <div class="fs-11" style="align-content:center">Meeting Expectations</div>
                </div>
                <div class="flex-row  mt-6">
                  <div class="label-pie mr-6" style="background-color: #FFD570;"></div>
                  <div class="fs-11" style="align-content:center">Needs Improvement</div>
                </div>
              </div>
            </div>
          </div>

          <div class="fc-000 ">
            <div class="fs-14 fw-700">Highest Rated</div>
            <div class="fs-12 pt-6" style="color: #000000; opacity: 0.6;">Individuals with the highest peer feedback
              ratings, out of 4 stars</div>
            <div v-for="(val, index) in highest" :key="val.emailKey">
              <div v-if="index < 5" class="flex-row-between pt-12">
                <div class="flex-row">
                  <div class="pr-12 fs-12" style="align-content:center">{{ index + 1 }}</div>
                  <img v-if="val.profilepic" v-lazy="val.profilepic" :key="val.profilepic"
                    class="image-skeleton image-profile-24 flex-mid "
                    :class="[ blurMode ?  'blurelement': '' ]" />
                  <div v-else class="image image-profile-24 flex-mid"
                  :class="[ blurMode ?  'blurelement': '' ]">
                    <div class="text-in-image text-in-image-24 flex-mid">
                      {{
        $utils("acronymName", {
          firstName: val.firstname,
          lastName: val.lastname,
        })
      }}
                    </div>
                  </div>
                  <div class="pl-6 fs-13 fw-500"
                  :class="[ blurMode ?  'blurelement': '' ]"
                    style="align-content:center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 140px;">
                    {{ val.firstname }} {{ val.lastname }}</div>

                </div>
                <div class="pl-8 fs-12 " style="align-content:center">{{ val.ratingavg }} ⭐</div>
              </div>
            </div>
            <div class="fc-32C2D5 fw-600 pt-12 cursor-pointer" @click="openModalMember(highest, 'highest')">see all</div>
          </div>
          <div class="fc-000 ">

            <div class="fs-14 fw-700 ">Lowest Rated</div>
            <div class="fs-12 pt-6" style="color: #000000; opacity: 0.6;">Individuals with the lowest peer feedback
              ratings,
              out of 4 stars</div>
            <div v-for="(val, index) in lowest" :key="val.emailKey">
              <div v-if="index < 5" class="flex-row-between pt-12">
                <div class="flex-row">
                  <div class="pr-12 fs-12" style="align-content:center">{{ index + 1 }}</div>
                  <img v-if="val.profilepic" v-lazy="val.profilepic" :key="val.profilepic"
                    class="image-skeleton image-profile-24 flex-mid "
                    :class="[ blurMode ?  'blurelement': '' ]" />
                  <div v-else class="image image-profile-24 flex-mid"
                  :class="[ blurMode ?  'blurelement': '' ]">
                    <div class="text-in-image text-in-image-24 flex-mid">
                      {{
        $utils("acronymName", {
          firstName: val.firstname,
          lastName: val.lastname,
        })
      }}
                    </div>
                  </div>
                  <div class="pl-6 fs-13 fw-500"
                  :class="[ blurMode ?  'blurelement': '' ]"
                    style="align-content:center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 140px;">
                    {{ val.firstname }} {{ val.lastname }}</div>

                </div>
                <div class="pl-8 fs-12" style="align-content:center">{{ val.ratingavg }} ⭐</div>
              </div>
            </div>
            <div class="fc-32C2D5 fw-600 pt-12 cursor-pointer" @click="openModalMember(lowest, 'lowest')">see all</div>
          </div>
        </div>

      </div>
      <div class="mt-30 fs-18 fw-700">Skills Proficiency</div>
      <div class="skill-Profictency mt-20">
        <div class="icon-buttom-loading flex-mid" v-if="loading">
          <loading-even></loading-even>
        </div>
        <div v-else class="grid-2-auto">

          <div class="flex-column p-24 mt-12 ml-12">
            <div class="fs-14 fw-700">Skills That People Excel At</div>
            <div class="fs-12 pt-6" style="color: #000000; opacity: 0.6;">The number of times a skill was selected (compared with previous time period)</div>
            <div v-for="(data, index) in skillexcel" :key="'skill_' + index + data.id" class="flex-row pt-15">
              <div class="fs-12 " style="color: #000000;opacity: 0.6;width: 10px;"> {{ index + 1 }}</div>
              <div class="fs-13 pl-15 cursor-pointer" style="color:#000000;width: 120px; text-decoration: underline;"
                @click="openModalDetails(data)">{{ data.name }}</div>
              <div class="fs-12 flex-row-between " style="width: 50px;">
                <div class="fs-12">{{ data.excel }}</div>
                <div v-if="list_month_select != 'All-time'" class="fs-10 pt-2 pr-4 fc-1AC362" :style="`color: ${data.compareexcel > 0
        ? '#1AC362'
        : '#F44336'
        };`">{{ data.compareexcel > 0 ? `+${data.compareexcel}` : data.compareexcel }}</div>
              </div>


              <div class="bar-excel" :style="`width:${data.bar_width_excel * .8}px;`"></div>

            </div>
            <!-- <div class="fs-13 fc-6C30CC" style="border: 1px solid #6C30CC;border-radius: 6px;opacity: 1;margin-top:27px;width: 293px;height: 38px;text-align: center;align-content:center">See L&D special offers from our partners</div> -->
          </div>
          <div class="flex-column p-24 mt-12">
            <div class="fs-14 fw-700">Skills That People Could Improve At</div>
            <div class="fs-12 pt-6" style="color: #000000; opacity: 0.6;">The number of times a skill was selected (compared with previous time period)</div>
            <div v-for="(data, index) in skillimpoves" :key="'skill_' + index + data.id" class="flex-row pt-15">
              <div class="fs-12 " style="color: #000000;opacity: 0.6;width: 10px;"> {{ index + 1 }}</div>
              <div class="fs-13 pl-15 cursor-pointer" style="color:#000000;width: 120px; text-decoration: underline;"
                @click="openModalDetails(data)">{{ data.name }}</div>
              <div class="fs-12 flex-row-between " style="width: 50px;">
                <div class="fs-12">{{ data.improve }}</div>
                <div v-if="list_month_select != 'All-time'" class="fs-10 pt-2 pr-4 fc-1AC362" :style="`color: ${data.compareimprove > 0
        ? '#1AC362'
        : '#F44336'
        };`">{{ data.compareimprove > 0 ? `+${data.compareimprove}` : data.compareimprove }}</div>
              </div>

              <div class="bar-improve" :style="`width:${data.bar_width_improve * .8}px;`"></div>

            </div>
          </div>
        </div>
      </div>

    </div>



    <div class="remove-padding-modal">
      <el-dialog :visible.sync="detailsModalStatus" width="1100px" top="8vh">
        <div class="detail-container-grid">
          <div class="left-card skill-display">
            <div class="title">{{ skillsModalData.name }}</div>
            <div class="excels">
              <div class="flex-center title-label">
                <div>Excels at</div>
                <div class="ml-auto">
                  {{ skillsModalData.excel }}
                </div>
              </div>
              <div class="bar-container">
                <div class="bar-solid" :style="{ width: skillsModalData.excelsAt.solid + 'px' }"></div>

              </div>
              <div>
                <div v-for="(value, index) in (skillsModalData.attributes || []).sort((a, b) => (b.excelsScore || 0) - (a.excelsScore || 0))" :key="'attribute_' + index"
                  class="attribute-conainter">
                  <div class="number flex-center">{{ index + 1 }}</div>
                  <div class="">
                    <div class="description">
                      {{ value.label }}
                    </div>
                    <div class="bar-conainter flex-center">
                      <div class="spilt-bar flex-center excels-bar">
                        <div class="bar">
                          <div class="score" :style="{
        width: (value.excelsScore || 0) + '%',
      }"></div>
                        </div>
                        {{ value.excelsScore || 0 }}%
                      </div>

                    </div>
                  </div>
                </div>
              </div>



            </div>
            <div class="could-further-improve mt-21">
              <div class="flex-center title-label">
                <div>Could further improve</div>
                <div class="ml-auto">
                  {{ skillsModalData.improve }}
                </div>
              </div>
              <div class="bar-container">
                <div class="bar-solid" :style="{
        width: (skillsModalData.couldFurtherImprove.solid || 0) + 'px',
      }"></div>

              </div>
            </div>
            <!-- <div class="mt-24 opa-05 fs-13 fw-700">By attribute</div> -->
            <div>
              <div v-for="(value, index) in (skillsModalData.attributes || []).sort((a, b) => (b.couldFurtherImproveScore || 0) - (a.couldFurtherImproveScore || 0))" :key="'attribute_' + index"
                class="attribute-conainter">
                <div class="number flex-center">{{ index + 1 }}</div>
                <div class="">
                  <div class="description">
                    {{ value.label }}
                  </div>
                  <div class="bar-conainter flex-center">

                    <div class="spilt-bar flex-center could-further-improve-bar">
                      <div class="bar">
                        <div class="score" :style="{
        width: (value.couldFurtherImproveScore || 0) + '%',
      }"></div>
                      </div>
                      {{ value.couldFurtherImproveScore || 0 }}%
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="btn btn-generate">
              Generate Learning & Development Plan
            </div> -->
          </div>
          <div class="right-card">
            <div class="title mb-16">
              {{ skillsModalData.excelsAt.members.length }} members excel
            </div>
            <div class="thin-scrollbar pb-12" style="max-width: 626px">
              <div v-for="row in [1, 2, 3, 4]" class="members-container" :key="'members_excels_container_' + row">
                <div v-for="(member, index) in skillsModalData.excelsAt.members" :key="'excelsAt_member_' + index">
                  <div v-if="index == row - 1 || (index + 1 - row) % 4 == 0" class="member-card"
                  :class="[ blurMode ?  'blurelement': '' ]">
                    <div class="flex-center">
                      <div class="image-container">
                        <div v-if="member.imageProfile">
                          <img v-lazy="member.imageProfile" :key="'excelsAt_' + member.name"
                            class="image-skeleton image-profile-32" />
                        </div>
                        <div v-else class="image image-profile-32">
                          <div class="text-in-image text-in-image-42 flex-mid">
                            {{
        $utils("acronymName", {
          fullName: member.name,
        })
      }}
                          </div>
                        </div>
                      </div>
                      <div class="ml-8" style="width: 130px">
                        <div class="name ellipsis">{{ member.name }}</div>
                        <div class="team ellipsis">{{ member.teamname }}</div>
                      </div>
                    </div>
                    <div class="bar-6-percentage-coontainer">
                      <div v-for="(percentage, index) in [0, 1, 2, 3, 4, 5]" :key="index" class="percentage-6" :class="`${member.scorePercentage > percentage * (100 / 6)
          ? 'excels'
          : ''
        }`"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="title mt-22 mb-16">
              {{ skillsModalData.couldFurtherImprove.members.length }}
              members could further improve
            </div>
            <div class="thin-scrollbar pb-12" style="max-width: 626px">
              <div v-for="(row, index) in [1, 2, 3, 4]" :key="index" class="members-container">
                <div v-for="(member, index) in skillsModalData.couldFurtherImprove
        .members" :key="'couldFurtherImprove_member_' + index">
                  <div v-if="index == row - 1 || (index + 1 - row) % 4 == 0" class="member-card"
                  :class="[ blurMode ?  'blurelement': '' ]">
                    <div class="flex-center">
                      <div class="image-container">
                        <div v-if="member.imageProfile">
                          <img v-lazy="member.imageProfile" :key="'cuold_' + member.name"
                            class="image-skeleton image-profile-32" />
                        </div>
                        <div v-else class="image image-profile-32">
                          <div class="text-in-image text-in-image-42 flex-mid">
                            {{
        $utils("acronymName", {
          fullName: member.name,
        })
      }}
                          </div>
                        </div>
                      </div>
                      <div class="ml-8" style="width: 130px">
                        <div class="name ellipsis">{{ member.name }}</div>
                        <div class="team ellipsis">{{ member.teamname }}</div>
                      </div>
                    </div>
                    <div class="bar-6-percentage-coontainer">
                      <div v-for="(percentage, index) in [0, 1, 2, 3, 4, 5]" :key="index" class="percentage-6" :class="`${member.scorePercentage > percentage * (100 / 6)
          ? 'could-further-improve'
          : ''
        }`"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>

    <div>
      <el-dialog :visible.sync="detailsModalMember" width="704px" height="811" top="8vh">
        <div class="flex-column">
          <div class="fs-20 fw-700" style="margin-top: -20px;">Peer Feedback Rating</div>
          <div class="flex-row mt-16">
            <el-input class="input-style" style="height: 40px" autosize :placeholder="$t('members.Search')"
              @keyup.native="searchData(inputSearch)" v-model="inputSearch" clearable></el-input>
            <div class="pl-20">
              <svg
                    @click="exportdata()"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            class="icon-export"
          >
            <path
              fill="currentColor"
              d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"
                    />
                  </svg>
            </div>
          </div>
          <div class="mt-46">
            <el-table :data="members">
              <el-table-column prop="rank" label="Rank" width="60" align="center"></el-table-column>
              <el-table-column width="42">
                <template slot-scope="scope">
                  <div class="absolute-mid">
                    <img v-if="scope.row.profilepic" v-lazy="scope.row.profilepic" :key="scope.row.profilepic"
                      class="image-skeleton image-profile-42 flex-mid mx-10"
                      :class="[ blurMode ?  'blurelement': '' ]" />
                    <div v-else class="image image-profile-42 flex-mid"
                    :class="[ blurMode ?  'blurelement': '' ]">
                      <div class="text-in-image text-in-image-42 flex-mid">
                        {{
        $utils("acronymName", {
          firstName: scope.row.firstname,
          lastName: scope.row.lastname,
        })
      }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column prop="name" sortable="custom" :label="$t('members.Member')" width="184">
                <template slot-scope="scope">
                  <div class="flex-column">
                    <span class="text-name"
                    :class="[ blurMode ?  'blurelement': '' ]">{{ scope.row.firstname }} {{ scope.row.lastname }}</span>
                    <span class="text-email"
                    :class="[ blurMode ?  'blurelement': '' ]">{{ scope.row.email }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="ratingavg" label="Average Rating" width="180" align="center"></el-table-column>
              <el-table-column prop="interaction" label="Interactions" width="180" align="center"></el-table-column>
            </el-table>
          </div>
          <div class="flex-center pagination mt-10">
            <el-pagination @current-change="handleCurrentChange" :current-page="page" :page-size="10" :pager-count="5"
              layout="prev, pager, next" :total="totol_data"></el-pagination>
            <span class="results-status">
              {{ totol_data > 10 ? 10 : totol_data }}
              {{ $t("members.results_from") }}
              {{ $utils("addCommasInNumber", totol_data) }}
              {{ $t("members.results") }}
            </span>
          </div>
        </div>
      </el-dialog>
    </div>


  </div>

</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  name: "proficiencies",
  components: {
    loadingEven: require("../even/loading").default,
  },
  created() {
    this.$store.dispatch("team/getTeamsOptionsFixed", this.user);
    //this.$store.dispatch("insightsManagers/getDataAll");
    this.$store.dispatch("skillOverview/getOrganization1level");
    // this.$store.dispatch("skillOverview/getData");
  },
  watch: {
    optionsTeam() {
      if (this.optionsTeam.length > 0) {
        this.selectTeam =
          this.user.user_type == "leadership" ? this.user.team : "all";
      }
    },
    datachart() {
      if (this.myChart) this.myChart.destroy();
      this.createChart();
    },
    loading() {
      setTimeout(() => {
        this.createChart();
      }, 300);
    },
    selectTeam() {
      this.$store.dispatch("insightsManagers/setTeamSorting", this.selectTeam);
    },
    inputSearch() {
      setTimeout(() => {
        this.searchData(this.inputSearch)
      }, 500);
    },

  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    optionsTeam() {
      return this.$store.getters["team/teamsfixedall"];
    },
    loading() {
      return this.$store.getters["skillOverview/loading"];
    },
    datachart() {
      return this.$store.getters["skillOverview/datachart"];
    },
    max_y() {
      return this.$store.getters["skillOverview/max_y"];
    },
    max_x() {

      return this.$store.getters["skillOverview/max_x"];
    },
    skillProficiencyAndDeficiency() {

      return this.$store.getters["skillOverview/skillProficiencyAndDeficiency"];
    },
    checkedSkillTypeOption() {
      return this.$store.getters["skillOverview/checkedSkillTypeOption"];
    },
    attributes() {
      return this.$store.getters["skillOverview/attributes"];
    },
    userData() {
      return this.$store.getters["skillOverview/userData"];
    },
    highest() {
      return this.$store.getters["skillOverview/highest"];
    },
    lowest() {
      return this.$store.getters["skillOverview/lowest"];
    },
    skillexcel() {
      return this.$store.getters["skillOverview/skillexcel"];
    },
    skillimpoves() {
      return this.$store.getters["skillOverview/skillimpoves"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },


  },
  data() {
    return {
      myChart: "",
      selectTeam: "",
      SortBy: "Proficiency",
      loadingOverview: true,
      userDetail: {},
      detailsModalStatus: false,
      // checkedSkillTypeOption: [{ type: "Details" }, { type: "Risk-taking" }],
      skillFilterList: [],
      checkedSkillType: [],
      detailsModalMember: false,
      inputSearch: '',
      page: 1,
      totol_data: 0,
      data_dialog: [],
      // mock data
      // skillProficiencyAndDeficiency: [
      //   {
      //     name: "Details",
      //     id: "details",
      //     excelsAt: {
      //       solid: 40,
      //       gradientFill: 60,
      //       members: [
      //         {
      //           name: "John Doe1",
      //           id: "john-doe",
      //           teamname: "Team 1",
      //           imageProfile: "",
      //           scorePercentage: 90,
      //         },
      //         {
      //           name: "John Doe2",
      //           id: "john-doe",
      //           teamname: "Team 1",
      //           imageProfile: "",
      //           scorePercentage: 20,
      //         },
      //         {
      //           name: "John Doe3",
      //           id: "john-doe",
      //           teamname: "Team 1",
      //           imageProfile: "",
      //           scorePercentage: 0,
      //         },
      //         {
      //           name: "John Doe4",
      //           id: "john-doe",
      //           teamname: "Team 1",
      //           imageProfile: "",
      //           scorePercentage: 1,
      //         },
      //         {
      //           name: "John Doe5",
      //           id: "john-doe",
      //           teamname: "Team 1",
      //           imageProfile: "",
      //           scorePercentage: 50,
      //         },
      //         {
      //           name: "John Doe6",
      //           id: "john-doe",
      //           teamname: "Team 1",
      //           imageProfile: "",
      //           scorePercentage: 80,
      //         },
      //         {
      //           name: "John Doe7",
      //           id: "john-doe",
      //           teamname: "Team 1",
      //           imageProfile: "",
      //           scorePercentage: 80,
      //         },
      //         {
      //           name: "John Doe8",
      //           id: "john-doe",
      //           teamname: "Team 1",
      //           imageProfile: "",
      //           scorePercentage: 80,
      //         },
      //         {
      //           name: "John Doe9",
      //           id: "john-doe",
      //           teamname: "Team 1",
      //           imageProfile: "",
      //           scorePercentage: 80,
      //         },

      //       ],
      //     },
      //     couldFurtherImprove: {
      //       solid: 20,
      //       gradientFill: 45,
      //       members: [
      //         {
      //           name: "John Doec",
      //           id: "john-doec",
      //           teamname: "Team c",
      //           imageProfile: "",
      //           scorePercentage: 80,
      //         },
      //       ],
      //     },
      //   },
      //   {
      //     name: "Risk-taking",
      //     id: "Risk-taking",
      //     excelsAt: {
      //       solid: 40,
      //       gradientFill: 60,
      //       members: [
      //         {
      //           name: "John Doe",
      //           id: "john-doe",
      //           teamname: "Team 1",
      //           imageProfile: "",
      //           scorePercentage: 80,
      //         },
      //         {
      //           name: "John Doe",
      //           id: "john-doe",
      //           teamname: "Team 1",
      //           imageProfile: "",
      //           scorePercentage: 80,
      //         },
      //         {
      //           name: "John Doe",
      //           id: "john-doe",
      //           teamname: "Team 1",
      //           imageProfile: "",
      //           scorePercentage: 80,
      //         },
      //       ],
      //     },
      //     couldFurtherImprove: {
      //       solid: 20,
      //       gradientFill: 45,
      //       members: [
      //         {
      //           name: "John Doec",
      //           id: "john-doec",
      //           teamname: "Team c",
      //           imageProfile: "",
      //           scorePercentage: 80,
      //         },
      //         {
      //           name: "John Doec",
      //           id: "john-doec",
      //           teamname: "Team c",
      //           imageProfile: "",
      //           scorePercentage: 20,
      //         },
      //       ],
      //     },
      //   },
      // ],
      // lowest:[{

      //           name: "John Doec",
      //           id: "john-doec",
      //           teamname: "Team c",
      //           imageProfile: "",
      //           star: "2.0",
      //           firstName:'John',
      //           lastName:'Doec'

      // },{

      //                name: "John Doec",
      //                id: "john-doec",
      //                teamname: "Team c",
      //                imageProfile: "",
      //                star: "2.0",
      //                firstName:'John',
      //                lastName:'Doec'

      //      },{

      //                name: "John Doec",
      //                id: "john-doec",
      //                teamname: "Team c",
      //                imageProfile: "",
      //                star: "2.0",
      //                firstName:'John',
      //                lastName:'Doec'

      //      },{

      //                name: "John Doec",
      //                id: "john-doec",
      //                teamname: "Team c",
      //                imageProfile: "",
      //                star: "2.0",
      //                firstName:'John',
      //                lastName:'Doec'

      //      },{

      //                name: "John Doec",
      //                id: "john-doec",
      //                teamname: "Team c",
      //                imageProfile: "",
      //                star: "2.0",
      //                firstName:'John',
      //                lastName:'Doec'

      //      }],
      // highest:[{

      //                name: "John Doec1",
      //                id: "john-doec1",
      //                teamname: "Team c",
      //                imageProfile: "",
      //                star: "2.0",
      //                firstName:'John1',
      //                 lastName:'Doec1'

      //      },{

      //                name: "John Doec",
      //                id: "john-doec",
      //                teamname: "Team c",
      //                imageProfile: "",
      //                star: "2.0",
      //                firstName:'John',
      //                lastName:'Doec'

      //      },{

      //                name: "John Doec",
      //                id: "john-doec",
      //                teamname: "Team c",
      //                imageProfile: "",
      //                star: "2.0",
      //                firstName:'John',
      //                lastName:'Doec'

      //      },{

      //                name: "John Doec",
      //                id: "john-doec",
      //                teamname: "Team c",
      //                imageProfile: "",
      //                star: "2.0",
      //                firstName:'John',
      //                lastName:'Doec'

      //      },{

      //                name: "John Doec",
      //                id: "john-doec",
      //                teamname: "Team c",
      //                imageProfile: "",
      //                star: "2.0",
      //                firstName:'John',
      //                lastName:'Doec'

      //      }],
      skillProficiencyAndDeficiencyModalStatus: false,
      list_month_select: "Past 6-months",
      skillsModalData: {
        name: "",
        id: "",
        excelsAt: {
          solid: 0,
          gradientFill: 0,
          members: [],
        },
        couldFurtherImprove: {
          solid: 0,
          gradientFill: 0,
          members: [],
          attributes: [],
        },
      },
      members: [{

      }],
      data_Search: []
    };
  },
  mounted() {
    if (this.optionsTeam.length > 0 && this.selectTeam == "") {
      this.selectTeam =
        this.user.user_type == "leadership" ? this.user.team : "all";
    }
    this.createChart();
    setTimeout(() => {
      this.loadingOverview = false;
    }, 2000);
  },
  methods: {
    exportdata() {
      let data = []
      if (this.inputSearch != '') {
        data = this.data_Search;
      } else {
        data = this.data_dialog;
      }

      const Excel = require('exceljs');
      var wb = new Excel.Workbook();
      var ws = wb.addWorksheet('peer-feeedback-ratings');
      let company = ''
      /*TITLE*/
      ws.getRow(1).height = 20
      ws.getCell('A1').font = { name: 'Arial', size: 12, bold: true }
      ws.getCell('A1').alignment = { vertical: 'middle' }
      // ws.getCell('A1').value = `${company.name} Performance Review Data Downloaded on ${format(new Date(),'MMMM DD,YYYY')}`

      // /*Column headers*/
      ws.getColumn('A').width = 25;
      ws.getColumn('B').width = 10;
      ws.getColumn('C').width = 10;
      ws.getColumn('D').width = 10;
      ws.getColumn('E').width = 10;
      ws.getRow(1).values = ['Rank', 'Name completed', 'Team', 'Average Rating', 'Interactions']

      // /*Data*/
      _.forEach(data, (item, key) => {
        company = item.company
        let _tmp = [
          item.rank,
          item.firstname + ' ' + item.lastname,
          item.teamname,
          item.ratingavg,
          item.total,

        ];
        ws.addRow(_tmp);

      });




      wb.xlsx.writeBuffer({
        base64: true
      })
        .then(function (xls64) {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

          var url = URL.createObjectURL(data);
          a.href = url;
          a.download = company + '-peer-feeedback-ratings' + ".xlsx";
          document.body.appendChild(a);
          a.click();
          setTimeout(function () {

            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          },
            0);
        })
        .catch(function (error) {
          console.log(error.message);
        });


    },
    changeTime(time) {
      this.list_month_select = time;
      this.$store.dispatch("skillOverview/changeTime", time);
      // console.log('time',time)
    },
    openModalDetails(data) {
      // console.log(data.couldFurtherImprove)
      // console.log(data.couldFurtherImprove.solid)

      // TODO: Add data to modal
      this.skillsModalData = data;
      this.skillsModalData.attributes = this.attributes[data.name]
      this.detailsModalStatus = true;
      // [
      //   {
      //     label: "Paying close attention to small details",
      //     excelsScore: 80,
      //     couldFurtherImproveScore: 20,
      //   },
      //   {
      //     label: "Taking the time to thoroughly complete a task",
      //     excelsScore: 40,
      //     couldFurtherImproveScore: 39,
      //   },
      //   {
      //     label: "Critically evaluating information",
      //     excelsScore: 52,
      //     couldFurtherImproveScore: 14,
      //   },
      // ];
    },
    openModalMember(data, type) {
      // console.log('this.highest.slice(0,10);',this.highest.slice(0,10))
      for (const i in data) {
        if (type == 'highest') {
          data[i].rank = data[i].rank_highest
        } else {
          data[i].rank = data[i].rank_lowest
        }
      }
      this.inputSearch = ''
      this.data_dialog = data;
      this.detailsModalMember = true;
      this.members = data.slice(0, 10);
      this.totol_data = data.length;

    },
    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.inputSearch != '') {
        this.members = this.data_Search.slice(((val - 1) * 10), (10 * val));
      } else {
        this.members = this.data_dialog.slice(((val - 1) * 10), (10 * val));
      }


    },
    searchData(val) {
      var re = new RegExp(val, 'gi')
      let _tableData = []
      for (const key in this.data_dialog) {
        const tableData = this.data_dialog

        if (tableData[key].firstname.match(re)) {
          _tableData.push(tableData[key])
        } else if (tableData[key].lastname.match(re)) {
          _tableData.push(tableData[key])
        }
      }
      this.data_Search = _tableData;
      this.totol_data = _tableData.length;
      this.members = _tableData.slice(0, 10);
    },
    handleSelectAllSkillType() {
      if (this.checkedSkillType.length !== this.checkedSkillTypeOption.length) {
        let checked = [];
        for (const i in this.checkedSkillTypeOption) {
          checked.push(this.checkedSkillTypeOption[i].type);
        }
        this.checkedSkillType = checked;
      }
    },
    clearQuestionTypeSelected() {
      this.checkedSkillType = this.skillFilterList;
      this.$refs.dropdownValuesMenu.visible = false;
    },
    saveQuestionTypeFiltered() {
      this.skillFilterList = this.checkedSkillType;
      this.$store.dispatch("skillOverview/filtersData", this.checkedSkillType);

      this.$refs.dropdownValuesMenu.visible = false;
    },
    renderMemberPic(index) {
      if (index == 0) {
        return "";
      } else {
        return `left: ${index * -10}px; position: relative`;
      }
    },
    handleTeams(key) {
      this.selectTeam = key;
      this.$store.dispatch("skillOverview/getData", key);
    },
    sortBy(type) {
      this.SortBy = type;
      this.$store.dispatch("skillOverview/sortData", type);
    },
    getPointRadius() {
      let radiusArr = [];
      for (const i in this.datachart) {
        let minnimaxRadius = 0,
          maxRadius = 3;
        let directReport = this.datachart[i].size;
        let redius = this.datachart[i].size;//Math.trunc(directReport / 5 + (minnimaxRadius - 1));
        radiusArr.push(redius * 2);
        // if (redius < minnimaxRadius) {
        //   radiusArr.push(minnimaxRadius);
        // } else if (redius > maxRadius) {
        //   radiusArr.push(maxRadius);
        // } else {
        //   radiusArr.push(redius);
        // }
      }
      return radiusArr;
    },
    getPointColor() {
      let colorArr = [];
      for (const i in this.datachart) {
        // TODO: Fix color of node on here
        if (this.datachart[i].type == "excel") {
          colorArr.push("#00ACC1");
        } else if (this.datachart[i].type == "improves") {
          colorArr.push("#E45006");
        }
        //else {
        //   colorArr.push("#f44336");
        // }
      }
      return colorArr;
    },
    getPointTitle() {
      let title = [];
      for (const i in this.datachart) {
        // TODO: Fix label of node on here
        title.push(this.datachart[i].name);
      }
      return title;
    },
    createChart() {
      // console.log('this.datachart',this.datachart)
      var ratingChart = this.$refs.ratingChart;
      //let data = [...this.datachart];

      if (ratingChart) {
        const data = {

          datasets: [{
            label: 'Rating overview',
            data: this.datachart,
            backgroundColor: [
              '#6C30CC',
              '#8858d5',
              '#c1a9e8',
              '#FFD570'
            ],
            hoverOffset: 4
          }],
        };
        this.myChart = new Chart(ratingChart, {
          type: "pie",
          data: data,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.txtOption {
  color: #4a4a4a;
  font-size: 14px;
  margin-left: 16px;
  width: 158px;
  display: inline-block;
}

.menu-option-style {
  border-bottom: transparent;
  background: #f4f4f4;
  border-radius: 4px;
}

.chart-container {
  position: relative;
  height: 290px;
  margin-top: 16px;
  padding: 24px 24px 36px 48px;
  background-color: rgba(0, 0, 0, 0.03);
  border-radius: 24px;
}

.site-text {
  transform: rotate(-90deg);
  width: 300px;
  position: absolute;
  margin-top: 90px;
  margin-left: -128px;
}

.image-profile-32 {
  border: 2px solid #ffffff;
}

.skill-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 17px 20px;
  margin-bottom: 52px;

  .skill-card {
    border-radius: 6px;
    border: 1px solid #ddd;
    padding: 24px;
  }
}

.skill-display {
  .title {
    font-size: 18px;
    font-weight: 900;
  }

  .title-label {
    font-size: 14px;
    font-weight: 700;
    margin-top: 24px;
    margin-bottom: 4px;
  }


  .bar-container {
    margin-top: 4px;
    margin-bottom: 8px;
    display: flex;

    .bar-gradient,
    .bar-solid {
      height: 16px;
      background: #ccc;
    }
  }

  .detail-link {
    font-size: 13px;
    font-weight: 700;
    color: #6c30cc;
    margin-top: 18px;
    text-decoration: underline;
    cursor: pointer;
  }

  .absolute-right {
    position: absolute;
    right: 0;
    opacity: 0.7;
    font-size: 13px;
  }

  .excels {
    .title-label {
      color: #00acc1;
    }

    .bar-gradient {
      background: linear-gradient(90deg, #d7f2f5, #f8f8f8) !important;
      border-radius: 4px;
    }

    .bar-solid {
      background: #00acc1;
      border-radius: 4px;
    }
  }

  .could-further-improve {
    .title-label {
      color: #e45006;
    }

    .bar-gradient {
      background: linear-gradient(90deg, #ffe4d6, #f8f8f8) !important;
      border-radius: 4px;
    }

    .bar-solid {
      background: #e45006;
      border-radius: 4px;
    }
  }
}

.drop-down-container {
  margin-left: 12px;
  height: 40px;
  border-radius: 4px;
  padding: 0 8px 0 12px;
}

.drop-down-container.active {
  margin-left: 10px;
  background-color: rgba(#32c2d5, 0.1);
  padding: 0 6px 0 10px;
}

.dropdownFooter {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 56px;
  padding-right: 16px;
  background: #f8f8f8;
  border-top: 1px solid #e8e8e8;

  .el-button--cancel {
    padding: 4px 16px;
    height: 24px;
    font-size: 13px;
    font-weight: 700;
    color: #747474;
    background-color: #e0e0e0;
    border-color: #e0e0e0;
  }

  .el-button--cancel:hover,
  .el-button--cancel:focus {
    color: #747474;
    background-color: #e0e0e0;
    border-color: #e0e0e0;
    opacity: 0.7;
  }

  .el-button--cancel:active {
    color: #747474;
    background-color: #e0e0e0;
    border-color: #e0e0e0;
    opacity: 1;
  }

  .el-button--save {
    padding: 4px 16px;
    height: 24px;
    font-size: 13px;
    font-weight: 700;
    color: #fff;
    background-color: #32c2d5;
    border-color: #32c2d5;
  }

  .el-button--save:hover,
  .el-button--save:focus {
    color: #fff;
    background-color: #32c2d5;
    border-color: #32c2d5;
    opacity: 0.7;
  }

  .el-button--save:active {
    color: #fff;
    background-color: #32c2d5;
    border-color: #32c2d5;
    opacity: 1;
  }
}

.el-dropdown-menu {
  width: 280px;
  padding-top: 0px;
  padding-bottom: 0px;
  border: 1px solid #e8e8e8;
}

.el-dropdown-menu__item {
  font-size: 13px;
  font-weight: 700;
  color: #292929;
  height: 24px;
  padding-bottom: 8px;
}

.el-dropdown-menu__item:hover,
.el-dropdown-menu__item:focus {
  cursor: default;
  background-color: initial !important;
}

.dropdownHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding-left: 24px;
  padding-right: 16px;
  margin-bottom: 10px;
  background: #f8f8f8;
  border-bottom: 1px solid #e8e8e8;
}

.dropdownHeaderTextStyle {
  font-size: 13px;
  font-weight: 700;
}

.el-button--text.dropdownHeaderTextStyle {
  color: #32c2d5;
}

.el-button--text.dropdownHeaderTextStyle:hover {
  color: #249fb0;
}

.el-button--text.dropdownHeaderTextStyle:active {
  color: #32c2d5;
}

.tooltipStyle {
  max-width: 240px;
}

.el-dropdown-menu {
  width: 280px;
  padding-top: 0px;
  padding-bottom: 0px;
  border: 1px solid #e8e8e8;
}

.el-dropdown-menu__item {
  font-size: 13px;
  font-weight: 700;
  color: #292929;
  height: 24px;
  padding-bottom: 8px;
}

.el-dropdown-menu__item:hover,
.el-dropdown-menu__item:focus {
  cursor: default;
  background-color: initial !important;
}

.drop-down-container {
  margin-left: 12px;
  height: 40px;
  border-radius: 4px;
  padding: 0 8px 0 12px;
}

.drop-down-container.active {
  margin-left: 10px;
  background-color: rgba(#32c2d5, 0.1);
  padding: 0 6px 0 10px;
}

.text-drop-down {
  color: #00acc1;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.detail-container-grid {
  display: grid;
  grid-template-columns: 450px auto;
  color: #000;

  .left-card,
  .right-card {
    padding: 60px 40px 42px;
  }

  .left-card {
    background: #f8f8f8;

    .excels .bar-gradient {
      background: linear-gradient(90deg, #d7f2f5, #f8f8f8) !important;
    }

    .could-further-improve .bar-gradient {
      background: linear-gradient(90deg, #ffe4d6, #f8f8f8) !important;
    }

    .attribute-conainter {
      display: grid;
      margin-top: 16px;
      grid-template-columns: 20px auto;

      .number {
        font-size: 13px;
        font-weight: 700;
        opacity: 0.3;
      }

      .description {
        font-size: 14px;
        font-weight: 500;
        word-break: normal;
      }

      .bar-conainter {
        display: grid;
        grid-template-columns: 1fr;
        gap: 17px;
        margin-top: 1px;

        .spilt-bar {
          display: grid;
          grid-template-columns: auto 36px;
          text-align: right;
          font-size: 12px;
          font-weight: 600;

          .bar {
            height: 6px;
            border-radius: 6px;
            position: relative;
            width: 100%;

            .score {
              position: absolute;
              height: 6px;
              border-radius: 6px;
              left: 0;
            }
          }
        }

        .excels-bar>.bar {
          background: #d7f2f5;

          .score {
            background: #00acc1;
          }
        }

        .could-further-improve-bar>.bar {
          background: #ffe4d6;

          .score {
            background: #e45006;
          }
        }
      }
    }
  }

  .right-card {
    background: #fff;
  }

  .title {
    font-size: 20px;
    font-weight: 900;
    margin-bottom: 16px;
  }
}

.btn-generate {
  height: 52px;
  background: #6c30cc;
  color: #fff;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 700;
  margin-top: 60px;

  &:hover {
    opacity: 0.9;
  }
}

.members-container {
  margin-top: 8px;
  display: flex;

  .member-card {
    border-radius: 6px;
    border: 1px solid #c7c7c7;
    padding: 10px 8px;
    width: 180px;
    margin-right: 8px;

    .image-container {
      height: 32px;
      width: 32px;
      margin-bottom: 8px;

      .image {
        height: 32px;
        width: 32px;
        border-radius: 50%;
        background: #ccc;
        position: relative;

        .text-in-image {
          color: #fff;
          font-size: 13px;
          font-weight: 700;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }

    .name {
      font-size: 13px;
      font-weight: 700;
      color: #4a4a4a;
    }

    .team {
      font-size: 14px;
      font-weight: 400;
      color: #000000;
      opacity: 0.6;
    }

    .score {
      font-size: 13px;
      font-weight: 700;
      color: #00acc1;
    }
  }
}

.bar-6-percentage-coontainer {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 2px;

  .percentage-6 {
    height: 3px;
    background: #00000033;
    border-radius: 6px;
    // width: calc(100% / 6);
  }

  .excels {
    background: #00acc1;
  }

  .could-further-improve {
    background: #e45006;
  }
}

.line-of-middle-chart {
  width: 100%;

  &:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: calc(100% - 14%);
    height: 1px;
    background: #ccc;
    transform: translate(-50%, -50%);
  }

  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1px;
    height: calc(100% - 16%);
    background: #ccc;
    transform: translate(-50%, -50%);
  }
}

.widht-label-of-chart {
  top: 0;
  position: absolute;
  width: 100%;

  .label-container {
    opacity: 0.5;
    font-size: 10px;
    color: #000;
    display: flex;
    justify-content: space-between;
    padding: 0 20px 0 22px;

    >div {
      width: 20px;
      display: flex;
      justify-content: center;
    }
  }
}

.skill-Profictency {
  top: 621px;
  left: 334px;
  min-width: 868px;
  min-height: 498px;
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 4px #00000029;
  border-radius: 4px;
  opacity: 1;
}

.overview {
  top: 277px;
  left: 334px;
  min-width: 868px;
  min-height: 290px;
  background: var(--unnamed-color-000000) 0% 0% no-repeat padding-box;
  background: #fafafa 0% 0% no-repeat padding-box;
  border-radius: 4px;

}

.label-pie {
  border-radius: 4px;
  width: 16px;
  height: 16px;

}

.bar-excel {
  top: 699px;
  left: 533px;

  height: 16px;
  background: transparent linear-gradient(90deg, #1DA2B4 0%, var(--unnamed-color-32c2d5) 100%) 0% 0% no-repeat padding-box;
  background: transparent linear-gradient(90deg, #1DA2B4 0%, #32C2D5 100%) 0% 0% no-repeat padding-box;
  border-radius: 4px;
  opacity: 1;
}

.bar-improve {
  top: 699px;
  left: 533px;
  width: 215px;
  height: 16px;
  background: transparent linear-gradient(90deg, #C34B0F 0%, #E45006 100%) 0% 0% no-repeat padding-box;
  border-radius: 4px;
  opacity: 1;
}

.menuOptionPowerup {
  width: 200px;
  border-radius: 4px;
  height: 40px;
}
</style>

<style lang="scss">
#menuDropdownType .el-submenu__title {
  height: 40px;
  line-height: 40px;
  background-color: #f4f4f4;
}
</style>
